import { useHandler } from "@redotech/react-util/hook";
import { useContext } from "react";
import { SettingsContext } from "../contexts/settings";
import { getPolicyLinkText } from "./dynamic-text-utils";

export interface UseFooterResponse {
  texts: { policyLinkButton: string };
  policyLinkTextClicked: () => void;
  notificationHtml: string | undefined;
}
export function useFooter(): UseFooterResponse {
  const settings = useContext(SettingsContext);

  const policyLinkTextClicked = useHandler(() => {
    window.open(settings?.theme.privacy_link);
  });

  return {
    texts: { policyLinkButton: getPolicyLinkText(settings) },
    notificationHtml: settings?.theme.notification,
    policyLinkTextClicked,
  };
}
